
// client/src/api.js
import writeClient from './sanityWrite';

const CONTACT_HELP_MESSAGE = 'We could not send your message right now. Your details are still here. Please try again later or call our office at +251 913 81 17 43.';

export const createContact = async (contactData) => {
  if (!process.env.REACT_APP_SANITY_WRITE_TOKEN) {
    throw new Error(CONTACT_HELP_MESSAGE);
  }

  try {
    const result = await writeClient.create({
      _type: 'contact',
      ...contactData,
      createdAt: new Date().toISOString(),
    });
    return result;
  } catch (error) {
    const statusCode = error.statusCode || error.response?.statusCode;
    console.error('Sanity contact submission failed:', {
      statusCode,
      message: error.message,
    });

    if (statusCode === 429) {
      throw new Error('We have received several messages recently. Please wait a few minutes and try again.');
    }

    throw new Error(CONTACT_HELP_MESSAGE);
  }
};
